import { memo, useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzChip, BzLoader, BzModal, BzModalBody, BzModalFooter, BzModalHeader, } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import { ORDERS_GRID_REF, deepClone, getMktSegIdFromApiExchangeName, getQtyType, getOrderDisplayDiscription } from '../../utils/global_functions';
import { ORDERS_TABKEY, ORDER_PRODUCT_TYPES, ORDER_TYPES, POSITION_TYPES } from '../../utils/global_variables';
import { updateIsSquareOff } from '../../redux/actions/netPosition';
import { _getQtyLotCaption } from '../../controllers';
import { formatScripDesc } from '../../controllers/netPosition';
import moment from 'moment';
import { _getOrderSlicingInfo } from '../../controllers/orders';
import { updateSliceRequestInfo } from '../../redux/actions/orders';

const OrderDetailModal = ({ title, message, btnLabel, onSubmit, activeOrderNetPositionChip, activeContent, ordersTabKey, checkScrips, setCheckScrips, bSquareOffAll, setbSquareOffAll, ...props }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const bIsCovertOrSquareOffPositionApiPending = useSelector(state => state?.netPosition?.bIsCovertOrSquareOffPositionApiPending);// Azeem K : 13-05-2024 : BT-102298 addeed loader on SquareOff positions
    const modalData = useSelector(state => state?.modals?.modalData);
    const overAllInterOpOff = useSelector(state => state?.netPosition?.overAllInterOpOff);
    const overAllPositions = useSelector(state => state?.netPosition?.overAllPositions);
    const todaysPostions = useSelector(state => state?.netPosition?.todaysPostions);
    const todaysInterOpOff = useSelector(state => state?.netPosition?.todaysInterOpOff);
    const squareOffAllEnabled = useSelector(state => state?.netPosition?.squareOffAllEnabled);
    const [allPositions, setAllPositions] = useState([]);
    const [bBtnDisabled, setbBtnDisabled] = useState(false);
    //BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - Start
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - End
    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
    //BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - Start
    useEffect(() => {
        if (bSquareOffAll) {
            let arrCheckScrips = [...checkScrips];
            //BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - Start
            const objSliceResp = _getOrderSlicingInfo(arrCheckScrips, objCFT, objLoginSession);
            let arrModifiedOrders = objSliceResp.arrOrders;
            dispatch(updateSliceRequestInfo(objSliceResp.sliceRequestData));
            //BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - End
            setCheckScrips([...arrModifiedOrders]);
        }
    }, [bSquareOffAll]); //BREEZE-16 :Order Slicing feature : ManasaB : 04-11-2024 :  SAT issue
    //BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - End
    //Vaibhav Singh: 05-02-24: BT-107431: Logic for updating overall opsition updted : Start
    useEffect(() => {
        if (activeContent === POSITION_TYPES.TODAYS) {
            let squaredOrders = todaysInterOpOff?.length ? todaysInterOpOff?.filter(each => Math?.abs(each?.net_quantity) > 0 && each?.product_type !== ORDER_PRODUCT_TYPES.BRACKET && each?.product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.BRACKET) : todaysPostions?.filter(each => Math?.abs(each?.net_quantity) > 0 && each?.product_type !== ORDER_PRODUCT_TYPES.BRACKET && each?.product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.BRACKET);
            setAllPositions(squaredOrders);
        } else {
            let squaredOrders = overAllInterOpOff?.length ? overAllInterOpOff?.filter(each => Math?.abs(each?.net_quantity) > 0 && each?.product_type !== ORDER_PRODUCT_TYPES.BRACKET && each?.product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.BRACKET) : overAllPositions?.filter(each => Math?.abs(each?.net_quantity) > 0 && each?.product_type !== ORDER_PRODUCT_TYPES.BRACKET && each?.product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.COVER && each?.api_product_type !== ORDER_PRODUCT_TYPES.BRACKET);
            setAllPositions(squaredOrders);
        }
    }, [todaysInterOpOff, overAllInterOpOff, activeContent, modals['ORDER_DETAILS_MODAL']]);
    //Vaibhav Singh: 05-02-24: BT-107431: Logic for updating overall opsition updted : End
    const onHide = () => {
        dispatch(handleModal([{ "ORDER_DETAILS_MODAL": false }]));
        dispatch(updateIsSquareOff(false));
        setbSquareOffAll(false);
    };
    const [buttonType, setButtonType] = useState('CANCEL ORDER');

    useEffect(() => {
        setCheckScrips(deepClone(allPositions));
    }, [allPositions]);

    const handleCheckBox = (e) => {
        let scripsCopy = checkScrips;
        if (e.target.checked) {
            scripsCopy.push(JSON.parse(e?.target.value));
            setCheckScrips([...scripsCopy]);
        } else {
            let nIndex = scripsCopy?.findIndex((eachScrip) => eachScrip?.id + eachScrip?.exchange === e?.target?.id);
            scripsCopy?.splice(nIndex, 1);
            setCheckScrips([...scripsCopy]);
            setbSquareOffAll(false);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            //Azeem K : 04-03-2024 : BT-102298 -MCX Net Position - Start
            setCheckScrips([...allPositions]);
            setbSquareOffAll(true);
            //Azeem K : 04-03-2024 : BT-102298 -MCX Net Position - End
        } else {
            setCheckScrips([]);
            setbSquareOffAll(false);
        }
    };

    useEffect(() => {
        //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
        if (checkScrips?.length <= 0 && activeOrderNetPositionChip === 'net_positions') {
            //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
            setbBtnDisabled(true);
        } else {
            setbBtnDisabled(false);
        }
    }, [checkScrips]);

    const hanldeOnGoBack = () => {
        dispatch(updateIsSquareOff(true));
        setbSquareOffAll(false);
    };
    // Mahesh S : 28-11-2023 : BT-102298 NSECDS Netposition – function for qty or lot - start
    const handleIsMinQtyToShow = (obj) => {
        const caption = _getQtyLotCaption(getMktSegIdFromApiExchangeName(obj.exchange), obj.market_lot, false);
        return caption;
    };
    // Mahesh S : 28-11-2023 : BT-102298 NSECDS Netposition – function for qty or lot - end

    useEffect(() => {
        if (activeOrderNetPositionChip === 'orders') {
            if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS || modalData?.type === 'Single Square Off') {
                setButtonType('SQUARE OFF ORDERS');
            } else {
                setButtonType('CANCEL ORDER');
            }
        } else if (activeOrderNetPositionChip === 'net_positions') {
            if (squareOffAllEnabled) {
                setButtonType('Done');
            } else {
                setButtonType('SQUARE OFF ORDERS');
            }
        }
    }, [activeOrderNetPositionChip, ordersTabKey, squareOffAllEnabled, modalData]);

    const selectedRows = activeOrderNetPositionChip === 'orders' ? (modalData?.type !== 'Single Square Off' ? ORDERS_GRID_REF?.current?.api?.getSelectedRows() : [modalData?.data]) : (modalData?.type !== 'Single Square Off' ? (bSquareOffAll ? checkScrips : allPositions) : modalData?.data?.data);
    return (
        <BzModal className='modal-breeze' show={modals['ORDER_DETAILS_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true" centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>{activeOrderNetPositionChip === 'orders' ? 'Cancel Order' : 'Square Off Orders'}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>

            <BzModalBody>
                <Container fluid className='p-0'>
                    {bIsCovertOrSquareOffPositionApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                        <BzLoader spinner={bIsCovertOrSquareOffPositionApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                    </div> : null}
                    <Row className='g-0 pb-2 mb-2 bdr-btm'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>{squareOffAllEnabled ? 'Select the scrips that you want to Square off' : (`Are you sure you want to ${activeOrderNetPositionChip === 'orders' ? 'cancel' : 'Square Off'} the following orders?`)}</div>
                        </Col>
                    </Row>
                    {squareOffAllEnabled ?
                        <Row className='g-0 mb-2'>
                            <Col md={12}>
                                <div className='form-check d-flex align-items-center'>
                                    <input type="checkbox" className='form-check-input'
                                        checked={checkScrips?.length === allPositions?.length ? true : false}
                                        onChange={handleSelectAll} id={'selectAll'}
                                    />
                                    <label htmlFor={'selectAll'}>
                                        <span className='font-medium font-size4 color-text ms-2 text-capitalize'>Select All</span>
                                    </label>
                                </div>
                            </Col>
                        </Row> : ''}
                    <Row className='g-0 mb-2'>
                        <Col md={12}>
                            {activeContent === ORDER_TYPES.MULTI_LEG ?
                                selectedRows?.map((row, i) =>
                                    <Row className='g-0 mb-2' key={i}>
                                        <Col md={10} className='d-flex flex-column align-items-start'>
                                            <div className='d-flex align-items-center'>
                                                <div className='font-medium font-size4 color-text text-uppercase me-2'>{row?.spread_symbol}</div>
                                                <div className='chips-wrap me-2'>
                                                    <BzChip className='exchange-chip text-capitalize'>{row?.exchange?.split('_')[0] || row?.preferred_exchange}</BzChip>
                                                </div>
                                            </div>
                                            <div className='font-regular font-enlarge color-subtext'>{`${moment((row?.leg_no_1?.expiry_date)).format("DDMMMYYYY").toUpperCase().slice(0, 2)} ${moment((row?.leg_no_1?.expiry_date)).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${row?.leg_no_1?.instrument?.slice(0, 3)} `}</div>
                                        </Col>
                                    </Row>)
                                : activeContent === ORDER_TYPES.SPREAD ? selectedRows?.map((row, i) => {
                                    return <Row className='g-0 mb-2' key={i}>
                                        <Col md={10} className='d-flex flex-column align-items-start'>
                                            <div className='d-flex flex-row align-items-center'>
                                                <div className='font-medium font-size4 color-text text-uppercase me-2'>{row?.spread_symbol}</div>
                                                <div className='chips-wrap me-2'>
                                                    <BzChip className='exchange-chip text-capitalize'>{row?.exchangeName || row?.preferred_exchange}</BzChip>
                                                </div>
                                                <div className='font-regular font-size4 color-subtext'>{getOrderDisplayDiscription(row)}</div>
                                                <div className='font-regular font-size4 color-subtext'>{`${moment((row?.leg_no_1?.expiry_date)).format("DDMMMYYYY").toUpperCase().slice(0, 2)} ${moment((row?.leg_no_1?.expiry_date)).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${row?.leg_no_1?.instrument?.slice(0, 3)}`}</div>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <div className={`font-medium font-size2 color-text ${row?.leg_no_1?.transaction_type?.toUpperCase() === "BUY" ? 'color-positive' : 'color-negative'}`}>{row?.leg_no_1?.transaction_type}</div>
                                                <div className='font-medium font-size2 color-text'> - </div>
                                                <div className={`font-medium font-size2 color-text ${row?.leg_no_2?.transaction_type?.toUpperCase() === "BUY" ? 'color-positive' : 'color-negative'}`}>{row?.leg_no_2?.transaction_type}:</div>
                                                <div className='font-regular font-size2 color-text ms-1'>{row?.leg_no_1?.total_quantity} {getQtyType(row?.exchangeName)} @ &#8377; {row?.leg_no_1?.order_price}</div>
                                            </div>
                                        </Col>
                                        <Col md={2} className='d-flex flex-column align-items-end'>
                                            <div className='font-regular font-size2 color-subtext'>Open</div>
                                            <div className='font-medium font-size2 color-text'>{row?.leg_no_1?.pending_quantity} {getQtyType(row?.exchangeName)}</div>
                                        </Col>
                                    </Row>;
                                }) : selectedRows?.map((row, i) => <>
                                    <Row className='g-0 my-3' key={i}>
                                        <Col md={10} className='d-flex flex-column align-items-start'>
                                            {
                                                activeOrderNetPositionChip === 'orders' ?
                                                    <div className='d-flex align-items-center'>
                                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{row?.title || row?.symbol}</div>
                                                        <div className='chips-wrap me-2'>
                                                            <BzChip className='exchange-chip text-capitalize'>{row?.exchange?.split('_')[0] || row?.preferred_exchange}</BzChip> {/* Azeem Khan: 20-12-2023 BT-120115 2nd Cycle */}
                                                        </div>
                                                        <div className='font-regular font-size4 color-subtext'>{getOrderDisplayDiscription(row)}</div>
                                                    </div>
                                                    :
                                                    <div className='d-flex align-items-center'>
                                                        {
                                                            squareOffAllEnabled &&
                                                            <div className='form-check d-flex align-items-center'>
                                                                <input type="checkbox" className='form-check-input' value={JSON.stringify(row)}
                                                                    checked={checkScrips?.some(element => element?.id + element?.exchange === row?.id + row?.exchange) ? true : false}
                                                                    onChange={handleCheckBox} id={row?.id + row?.exchange} />
                                                            </div>
                                                        }
                                                        <label htmlFor={row?.id + row?.exchange}>
                                                            <div className='font-medium font-size4 color-text text-uppercase me-2'>{row?.title}</div>
                                                        </label>
                                                        <div className='chips-wrap me-2'>
                                                            <BzChip className='exchange-chip'>{row?.displayExchange}</BzChip>
                                                        </div>
                                                        <div className='font-regular font-size2 color-subtext'>{formatScripDesc(row?.expiry_date, row?.instrument, row?.option_type, row?.strike_price)}</div>
                                                    </div>
                                            }
                                            <div className='d-flex align-items-center'>
                                                <div className={`font-medium font-size2 color-text ${row?.type?.toUpperCase() === "BUY" || row?.transaction_type?.toUpperCase() === "BUY" || (row?.net_quantity < 0) ? 'color-positive' : 'color-negative'}`}>{row?.type || row?.transaction_type || (row?.net_quantity > 0 ? 'Sell' : 'Buy')}: </div>
                                                <div className='font-regular font-size2 color-text ms-1'>{row?.totalQuantity || Math?.abs(row?.net_quantity) || row?.invested_qty_or_val} {buttonType !== 'CANCEL ORDER' ? handleIsMinQtyToShow(row) : getQtyType(row?.exchange)} @ &#8377; {buttonType === 'CANCEL ORDER' ? row?.price : (!(row?.order_type?.includes('MKT')) ? row?.ltp : 'Market')}</div>
                                            </div>
                                        </Col>
                                        <Col md={2} className='d-flex flex-column align-items-end'>
                                            <div className='font-regular font-size2 color-subtext'>{activeOrderNetPositionChip === 'orders' ? 'Open' : 'Execute'}</div>
                                            {activeOrderNetPositionChip === 'orders' ?
                                                <div className='font-medium font-size2 color-text'> {activeOrderNetPositionChip === 'orders' ? row?.pendingQuantity : (row?.buy_quantity || row?.executed_installments || 0 / row?.totalQuantity || row?.net_quantity || row?.no_of_installments)} {getQtyType(row?.exchange)}</div>
                                                : <div className='font-medium font-size2 color-text text-truncate'>{Math?.abs(row?.net_quantity) + '/' + Math?.abs(row?.modified_quantity)} {handleIsMinQtyToShow(row)}</div>}
                                        </Col>
                                    </Row>
                                    {/* BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - Start */}
                                    {row?.orderSlicingInfo?.length > 0 &&
                                        <Row className='g-0 mb-2' key={i}>
                                            <Col className='text-start alert-warning p-3'>
                                                {row?.orderSlicingInfo?.length > 0 && row?.orderSlicingInfo?.map(eachInfo => {
                                                    return <div className='d-flex align-items-center py-1'>
                                                        <div className='allocate-dot black-allocation me-2'>&nbsp;</div>
                                                        <div className='font-medium font-size2 me-1 p-t-1'>{eachInfo}</div>
                                                        <div className='font-regular font-size2 p-t-1'>will be placed</div>
                                                    </div>;
                                                })}
                                            </Col>
                                        </Row>}
                                    {/* BT-135270 : Breeze - Order Slicing feature : ManasaB : 02-07-2024 - End */}
                                </>
                                )}

                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    {squareOffAllEnabled ?
                        <Row className='g-0'>
                            <Col md={8} className='d-flex flex-row justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text ms-2'>Square-off Selected Orders</div>
                                <span className='notification-count font-regular mx-2'>{checkScrips?.length}</span>
                            </Col>
                            <Col md={4} className='text-end'>
                                <BzButton className='btn btn-md btn-primary text-uppercase ms-3' disabled={bBtnDisabled || bIsCovertOrSquareOffPositionApiPending} onClick={onSubmit}>{buttonType}</BzButton>
                            </Col>
                        </Row> :
                        bSquareOffAll ?
                            <Row className='g-0 justify-content-end'>
                                <Col md={8} className='d-flex justify-content-end'>
                                    <BzButton className='btn btn-md btn-outline d-flex justify-content-center align-items-center' onClick={hanldeOnGoBack}>
                                        <div className='icon-12 icon-backward-arrow icon-primary me-2'></div>
                                        <span>GO BACK</span>
                                    </BzButton>
                                    <BzButton className='btn btn-md btn-primary text-uppercase ms-3' disabled={bBtnDisabled || bIsCovertOrSquareOffPositionApiPending} onClick={onSubmit}>{buttonType}</BzButton>
                                </Col>
                            </Row> :
                            <Row className='g-0 justify-content-end'>
                                <Col md={8} className='text-end'>
                                    <BzButton className='btn btn-md btn-outline text-uppercase' onClick={onHide}>Close</BzButton>
                                    <BzButton className='btn btn-md btn-primary text-uppercase ms-3' disabled={bBtnDisabled || bIsCovertOrSquareOffPositionApiPending} onClick={onSubmit}>{buttonType}</BzButton>
                                </Col>
                            </Row>}
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(OrderDetailModal)

/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
